module.exports = __webpack_public_path__ + "img/insu-qa-card-question.17571dc9.png";